<template>
	<section>
		<!--工具条-->
		<div :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
				<div>
					<mark
					class="bgCard"
					v-if="showSeason"
					@click.stop="showSeason=false"
					></mark>
					<el-input placeholder="请选择季度" v-model="showValue" style="width:138px;" @focus="showSeason=true">
					<i slot="prefix" class="el-input__icon el-icon-date"></i>
					</el-input>
					<el-card
					class="box-card"
					style="width:322px;padding: 0 3px 20px;margin-top:10px;position:fixed;z-index:9999"
					v-if="showSeason"
					>
					<div slot="header" class="clearfix" style="text-align:center;padding:0">
						<button
						type="button"
						aria-label="前一年"
						class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
						@click="prev"
						></button>
						<span role="button" class="el-date-picker__header-label">{{year}}年</span>
						<button
						type="button"
						aria-label="后一年"
						@click="next"
						class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
						></button>
					</div>
					<div class="text item" style="text-align:center;">
						<el-button
						type="text"
						size="medium"
						style="width:40%;color: #606266;float:left;"
						@click="selectSeason(1)"
						>第一季度</el-button>
						<el-button
						type="text"
						size="medium"
						style="float:right;width:40%;color: #606266;"
						@click="selectSeason(2)"
						>第二季度</el-button>
					</div>
					<div class="text item" style="text-align:center;">
						<el-button
						type="text"
						size="medium"
						style="width:40%;color: #606266;float:left;"
						@click="selectSeason(3)"
						>第三季度</el-button>
						<el-button
						type="text"
						size="medium"
						style="float:right;width:40%;color: #606266;"
						@click="selectSeason(4)"
						>第四季度</el-button>
					</div>
					</el-card>
				</div>
					<!-- <el-date-picker type="month" v-model="filters.date"   style="width: 100%;"></el-date-picker> -->
                </el-form-item>
				<el-form-item>
					<create-form-button  @select-type="bornForm" ></create-form-button>
					<download-form-button    @select-type="clickBtn" ></download-form-button>
				</el-form-item>
			</el-form>
		</div>

		<div id="formCon"  v-loading="loading"   element-loading-text="报表生成中"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0.8)">
			<div id="title">
				<div class="title1"><span>{{projectName}}环境噪声状况分析报告</span></div>
				<div class="title2">
					<!-- <span class="span1">安徽科创中光科技有限公司</span> -->
					<span class="span2"> {{date2}}</span>
				</div>
				<div class="title3"><span>{{date2}}噪声日报</span></div>
			</div>
			<div id="con1">
				<div class="contitle">一、运行情况</div>
				<div class="contitle">1.设备运行情况</div>
				<p class="condes" v-if="totalData.statusStr==''">{{date1}}各站点监测设备整体运行正常。</p>
				<p class="condes"  v-else>{{date1}}各站点监测设备运行情况：{{totalData.statusStr}}。其他监测设备运行正常。</p>
				<div class="contitle">2.软件运行情况</div>
				<p class="condes">{{date1}}各平台运行状况良好，未进行功能调整或修复。</p>
			</div>
			<div id="con2">
				<div class="contitle">二、全区噪声</div>
				<div id="con2add"></div>
			</div>
			<div id="con3">
				<div class="contitle">1.噪声变化趋势（日均值折线图）</div>
				<div id="chart1" class="chartDiv1"></div>
				<div id="chart1img"></div>

				<div id="calimg" style="width:70%;margin:0 auto;text-align:center"  ></div>
			</div>
			<div id="con4">
				<div class="contitle">3.各点位值</div>
				<div id="con4add"></div>
			</div>
			<div id="con5">
				<div class="contitle">4.各点位均值排名情况</div>
				<div id="con5add"></div>
			</div>
			<div id="con6">
				<div class="contitle">5.各功能区达标率统计情况</div>
				<div id="con6add"></div>
				<div id="chart6" class="chartDiv1"></div>
				<div id="chart6img"></div>
			</div>
		</div>

	</section>
</template>

<script>
	import * as echarts from "echarts";
	import {getProjects,bornSeasonForm } from '../../api/api';
	import {formatDate4,formatDateForm2,formatDate3,setRgbAndCon} from '../../../static/fun.js';
	import {handleWindowPrint,drawEchartImg,initContent,deleteImg} from '../../../static/print.js';
	import html2Canvas from 'html2canvas'
	import CreateFormButton from '../../components/myButton/CreateFormButton.vue'
	import DownloadFormButton from '../../components/myButton/DownloadFormButton.vue'

	export default {
	components: { DownloadFormButton,CreateFormButton },
		data() {
			return {
				filters: {
					projectId: '',
					date:''
				},
				projects:[],
				projectName:'',

				totalData:{
					pluStr:'',
					allStr:'',
					statusStr:'',
					rateStr:'',
				},
				facList:[],
				facDic:[],
				aqiNum:{
					green:0,
					red:0,
					yellow:0,
					orange:0,
					black:0,
					violet:0
				},
				date1:'',
				date2:'',
				picArr:[],
				loading:false,
				BiType:1,
				chooseNames:[],
				today:'本季度',
				yesterday:'上季度',
				orderNum:3,

				showSeason:false,
				year:'', //默认当前年
				quarter :'',
				showValue: '' //页面上input的内容
			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="pdf"){
					this.exportPDF();
				}else if(type=="word"){
					this.exportWord();
				}
			},
			prev() {
				this.year = +this.year - 1
			},
			next() {
				this.year = +this.year + 1
			},
			selectSeason(quarter) {
				let result = {
					date: `${this.year}年${quarter}季度`,
					year: this.year,
					quarter: quarter
				}
				this.quarter=quarter;
				//发送事件给父元素
				this.$emit('getValue', result)
				this.showSeason = false
				this.showValue = `${this.year}年${quarter}季度`;


				//赋予合适的时间
				var date=new Date();
				date.setMonth((this.quarter-1)*3);
				date.setFullYear(this.year);
				date.setDate(1);
				this.filters.date=date;
			},

			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					
					this.projects = res.data.data;
					this.listLoading = false;
					if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.projectName=this.projects[0].name;
						
					}
				});
			},
			bornForm(){
				this.loading=true;
				this.getProjectName();
				this.getDate();
				var param={
					projectId:this.filters.projectId,
					date:formatDate3(this.filters.date),
					type:"quarter"
				}
				bornSeasonForm(param).then((res) => {
					this.loading=false;
					if(res.data.code!=200){
						this.$message({
							message: "查询失败，请重试",
							type: 'error'
						})
						return;
					}

					var resData=res.data.data;
					this.facList=resData.facList;
					this.facDic=resData.facDic;
					//部分数据赋值
					this.assignValue(resData);
					//渲染均值折线图
					this.initAvgChart(resData);
					//渲染环比情况
					this.initCirData(resData);
					//渲染排名情况
					this.initOrderData(resData);
					//渲染空气质量概况
					this.initTotalData(resData);
					//渲染达标率统计情况
					this.initRateData(resData);
				});
			},
			initTotalData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con2add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";
				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2"  width="40px">序号</td>'
									+'<td rowspan="2">点位名称</td>';
				var nameStr="";
				var unitStr="";
				var fac="";
				this.facList.forEach(element => {
					if(element=="primarypollutant"){
					}else{
						var name=JSON.parse(sessionStorage.getItem(element)).name;
						var lgd='('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						nameStr+='<td style="font-size:10px">'+name+'</td>';
						if(lgd!="()"){
							unitStr+='<td style="font-size:10px">'+lgd+'</td>';
						}else{
							unitStr+='<td style="font-size:10px"></td>';
						}
						fac=element;
					}
				})
				str+=nameStr+'</tr>';
				str+='<tr style="font-size:10px">'+unitStr+'</tr></thead>';
				//head结束，开始添加内容
				str+='<tbody>';
				var i=0;
				this.facDic[fac].orderDataList.forEach(ele => {
					str+='<tr>';
					str+='<td>'+(i+1)+'</td>';
					str+='<td>'+ele.name+'</td>';
					this.facList.forEach(element => {
						if(element=="primarypollutant"){
						}else{
							var value=this.facDic[element].orderDataList[i].today;
							if(value==null){
								value="";
							}
							str+='<td>'+value+'</td>';
						}
					});
					str+='</tr>';
					i++;
				});
				str+='</tbody></table>';
				div.innerHTML=str;
				body.appendChild(div);
			},
			initCirData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con4add');
				body.innerHTML='';
				this.facList.forEach(element => {
					if(element=="primarypollutant"||element=="aqi"){
					}else{
						var name=JSON.parse(sessionStorage.getItem(element)).name;
						var lgd=name+'('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						var div = document.createElement('div');
						div.className="con3div";
						var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2">序号</td>'
									+'<td rowspan="2">点位名称</td>'
									+'<td rowspan="2">功能区名称</td>'
									+'<td colspan="2">限值(dB)</td>'
									+'<td colspan="3">'+lgd+'</td>'
								+'</tr>'
								+'<tr>'
									+'<td>昼间</td>'
									+'<td>夜间</td>'
									+'<td>本季度</td>'
									+'<td>上季度</td>'
									+'<td>环比率</td>'
								+'</tr>'
							+'</thead>'
							+'<tbody>';
							var i=1;
							var dataList=this.facDic[element].orderDataList;
							dataList.forEach(ele => {
								var mnInfo=resData.devices[ele.mn];
								str+='<tr>'
									+'<td>'+i+'</td>'
									+'<td style="text-align:left">'+ele.name+'</td>'
									+'<td>'+mnInfo.functionalArea.name+'</td>'
									+'<td>'+mnInfo.functionalArea.day+'</td>'
									+'<td>'+mnInfo.functionalArea.night+'</td>'
									+'<td>'+(ele.today==null?'':ele.today)+'</td>'
									+'<td>'+(ele.yesterday==null?'':ele.yesterday)+'</td>'
									+'<td>'+(ele.rate==null?'':ele.rate)+'</td>'
									+'</tr>';
								i++;
							});
							str+='</tbody>';
						str+='</table>';
						str+='<p class="condes">'+this.date1+'，'+name+' 最低的是'+dataList[i-2].name+'，'+name+'最高的是'+dataList[0].name+'。</p>';
						div.innerHTML=str;
						body.appendChild(div);
					}
				})

				this.initChartdetail(resData);
			},
			initRateData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con6add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";

				var aData=[];
				var seriesData=[
					{
						type:'bar',
						name:'昼间',
						color:'#4DA2F7',
						data:[]
					},
					{
						type:'bar',
						name:'夜间',
						color:'#ED8A46',
						data:[]
					}
				];


				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
					+'<thead>'
						+'<tr>'
							+'<td rowspan="2">序号</td>'
							+'<td rowspan="2">功能区类型</td>'
							+'<td rowspan="2">个数</td>'
							+'<td colspan="2">昼间</td>'
							+'<td colspan="2">夜间</td>'
						+'</tr>'
						+'<tr>'
							+'<td>dB</td>'
							+'<td>%</td>'
							+'<td>dB</td>'
							+'<td>%</td>'
						+'</tr>'
					+'</thead>'
					+'<tbody>';
					var i=1;
					var dataList=resData.complianceRate;
					dataList.forEach(ele => {
						str+='<tr>'
							+'<td>'+i+'</td>'
							+'<td >'+ele.functionalAreaName+'</td>'
							+'<td>'+ele.count+'</td>'
							+'<td>'+ele.dayData+'</td>'
							+'<td>'+ele.dayRate+'</td>'
							+'<td>'+ele.nightData+'</td>'
							+'<td>'+ele.nightRate+'</td>'
							+'</tr>';
						i++;

						aData.push(ele.functionalAreaName);
						seriesData[0].data.push(ele.dayRate);
						seriesData[1].data.push(ele.nightRate);
					});
					str+='</tbody>';
				str+='</table>';
				div.innerHTML=str;
				body.appendChild(div);
			
				this.drawRateDataChart(aData,seriesData);  
				this.picArr.push("chart6");
			},
			drawRateDataChart:function(aData,seriesData) {
                this.chartLine = echarts.init(document.getElementById('chart6'));
                this.chartLine.setOption({
                      tooltip: {
                        trigger: 'axis',
                        formatter: function(params) {
                            var result = params[0].name+'<br>';
                            params.forEach(function(item) {
                                result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data+"%</span><br>"
                            });
                            return result;
                        },
                    },
                    legend: {
                        data: ["昼间","夜间"],
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10, // 设置高度
                    },
                    grid: {
                        left: '3%',
                        right: '6%',
                        bottom: '4%',
                        top:60,
                        containLabel: true
                    },
                    xAxis: {
                        name:'功能区类别',
                        data:aData
                    },
                    yAxis: {
                        type: 'value',
                        name:'达标率(%)',
                    },
                    series:seriesData
                 },true);
            },
			initOrderData(res){
				//先删除上次生成标签
				var body = document.getElementById('con5add');
				body.innerHTML='';
				this.facList.forEach(element => {
					if(element=="primarypollutant"||element=="aqi"){
					}else{
						var name=JSON.parse(sessionStorage.getItem(element)).name;
						var unit='('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						var div = document.createElement('div');
						div.className="con3div";
						var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2">排名</td>'
									+'<td rowspan="2">点位名称</td>'
									+'<td >'+name+'</td>'
								+'</tr>'
								+'<tr>'
									+'<td>'+unit+'</td>'
								+'</tr>'
							+'</thead>'
							+'<tbody>';
							var i=1;
							var dataList=this.facDic[element].orderDataList;
							dataList.forEach(ele => {
								str+='<tr>'
									+'<td>'+i+'</td>'
									+'<td style="text-align:left">'+ele.name+'</td>'
									+'<td>'+(ele.today==null?'':ele.today)+'</td>'
									+'</tr>';
								i++;
							});
							str+='</tbody>';
						str+='</table>';
							var minAndMax="";
							for(var i=0;i<this.orderNum;i++){
								minAndMax+=dataList[i].name;
								if(i!=this.orderNum-1){
									minAndMax+=",";
								}
							}
						str+='<p class="condes">'+this.date1+'，'+name+' 值最高的子站前'+this.orderNum+'名点位是：'+minAndMax+'。</p>';
						div.innerHTML=str;
						body.appendChild(div);
					}
				})
			},
			initAvgChart(resData){
				this.picArr=[];
				let aData=resData.timeList;
				var seriesData=[];
				var legendData=[];
				this.facList.forEach(element => {
					if(element=="aqi"||element=="primarypollutant"){
					}else{
						let facArr=this.facDic[element].avgList;
						var lgd=JSON.parse(sessionStorage.getItem(element)).name+'('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						var obj={
							name: lgd,
							type: 'line',
							data: facArr
						};
						seriesData.push(obj);
						legendData.push(lgd);
					}
				});
				this.drawLineChart(aData,seriesData,'chart1',legendData,'数据变化趋势图');  
				this.picArr.push("chart1");
			},
			initChartdetail(resData){
				//数据格式处理	
				let aData=resData.timeList;
				let mnstr=resData.devices;
				var i=0;
				this.chooseNames=[];
				var seriesDataAll=[];
				for (var j in mnstr) {//mn
					let deviceOne={};
					deviceOne.type='line';
					deviceOne.name=mnstr[j].name;
					deviceOne.nameTep=j;
					deviceOne.connectNulls=false;//null中断
					deviceOne.data=[];
					deviceOne.smooth=true;//光滑连接
					seriesDataAll.push(deviceOne);
					i++;
					this.chooseNames.push(mnstr[j].name);
				}
				var i=2;
				this.facList.forEach(fac => {
					if(fac=="primarypollutant"){
					}else{
						//获取数据
						var  seriesData= JSON.parse(JSON.stringify(seriesDataAll));
						for (let index = 0; index < seriesData.length; index++) {
							const element = seriesData[index];

							var data=resData.dataList[element.nameTep];
							for (let j = 0; j < data.length; j++) {
								const dataOne = data[j];
								element.data.push(dataOne[fac])
							}
						}

						var div = document.createElement('div');
						div.id="chart"+i;
						div.className="chartDiv2 con3div";
						var body = document.getElementById('con4add');
						body.appendChild(div);
						this.drawLineChart(aData,seriesData,"chart"+i,this.chooseNames,JSON.parse(sessionStorage.getItem(fac)).name+'趋势图'); 
						var div2 = document.createElement('div');
						div2.id="chart"+i+"img";
						div2.className="con3div";
						body.appendChild(div2);
						this.picArr.push("chart"+i);
						i++;
					}
				})
			},
			assignValue(resData){
					this.totalData.statusStr=resData.statusStr;
				this.orderNum=Math.min(Object.keys(resData.devices).length,5);
				this.totalData.allStr="";
				this.totalData.rateStr="";
				this.facList.forEach(element => {
					if(element=="primarypollutant"){
					}else if(element=="aqi"){
					}else{
						var fac=JSON.parse(sessionStorage.getItem(element));
						this.totalData.allStr+=fac.name+"值为"+this.facDic[element].today+fac.unit+",";
						var rate=this.getType(this.facDic[element].rate);
						if(rate!=""){
							this.totalData.rateStr+=fac.name+rate+",";					
						}			
					}
				});
				if(this.totalData.allStr!=""){
					this.totalData.allStr=this.totalData.allStr.substring(0,this.totalData.allStr.length-1);
				}
				if(this.totalData.rateStr!=""){
					this.totalData.rateStr=this.totalData.rateStr.substring(0,this.totalData.rateStr.length-1);
				}
			},
			getType(rate){
				if(rate==null){
					return "";
				} else if(rate.indexOf("-")==-1){
					return "上升"+rate;
				}else if(rate=="0%"){
					return "持平";
				}else{
					return "下降"+rate.split('-')[1];
				}
			},
			drawLineChart:function(aData,seriesData,id,legendData,title) {
				var tit = ['','',''];
				var lgdStyle={
					data: legendTep,
					top:40,
					itemWidth: 10,  // 设置宽度
					itemHeight: 10, // 设置高度
					x:'right'
				};
				var topH=parseInt(seriesData.length/4)*20+60;
				if(topH>200){
					topH=80;
					lgdStyle={
						type: 'scroll', //分页类型
						data: legendTep,
						top:40,
						itemWidth: 10,  // 设置宽度
						itemHeight: 10, // 设置高度
						x:'right'
					};
				}
                var legendTep = tit.concat(legendData);
               	var chart = echarts.init(document.getElementById(id));
                chart.setOption({
					backgroundColor: '#fff',
                    title: {
                        text: title,
                        x:'left'
                    },
                    toolbox: {
                        show : true
                    },
                    legend: lgdStyle,
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top:topH,
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
						data:aData,
						// "axisLabel":{
						// 	interval: 0,
						// 	rotate: 60,
                        //     margin:5,
						// }
                    },
                    yAxis: {
						type: 'value',
						scale: true
                    },
                    series:seriesData
            	},true);
            },
			exportPDF(){
				var flag=handleWindowPrint('#formCon',this.picArr);
				if(!flag){
					this.$message({
						message: "导出报表出错，请重试",
						type: 'error'
					})
				}
			},
			exportWord(){
				if(drawEchartImg(this.picArr)){
					var content=initContent('#formCon');
					var converted = htmlDocx.asBlob(content);
					saveAs(converted, this.projectName+"_"+this.date1+'.docx');
					deleteImg(this.picArr);

					return;
				}
			},
			getProjectName(){
				 this.projects.forEach(item => {
					if(this.filters.projectId==item.projectId){
						this.projectName=item.name;
						return;
					}
				});
			},
			getDate(){
				this.date1= `${this.quarter}季度`;
				this.date2=`${this.year}年${this.quarter}季度`;
			},
		},
		mounted() {
			this.getProjects();
			//time设为上个季度
			let now = new Date();
			// 获取当前日期的前三个月的月份
			// now.setMonth(2)
			let pastMonth = now.getMonth() - 3;
			// 修改月份，如果前三个月对应没有该日期，则向后延顺
			now.setMonth(pastMonth);


			//计算时间和季度
			this.year=now.getFullYear();
			let month = now.getMonth()+1;
			if (month >= 1 && month <= 3) {
				this.quarter=1;
			} else if (month >= 4 && month <= 6) {
				this.quarter=2;
			} else if (month >= 7 && month <= 9) {
				this.quarter=3;
			} else if (month >= 10 && month <= 12) {
				this.quarter=4;
			}
			this.showValue = `${this.year}年${this.quarter}季度`;

			//赋予合适的时间
			var date=new Date();
			date.setMonth((this.quarter-1)*3);
			date.setFullYear(this.year);
			date.setDate(1);
			this.filters.date=date;

			this.getDate();
		}
	}

</script>

<style>
	@import 'form.css';
</style>


// WEBPACK FOOTER //
// Season.vue?4b443da2